/**
 * Mobile sticky CTA — proxy only. Clicks the single Woo #place_order control.
 */

import { checkoutCanSubmit, syncCheckoutSubmitState } from './checkout-submit.js';

function getConfig() {
	return window.doneCommerce || {};
}

function readTotal() {
	const total =
		document.querySelector('.dc-checkout__sidebar .order-total .amount') ||
		document.querySelector('#order_review .order-total .amount') ||
		document.querySelector('.order-total .woocommerce-Price-amount');
	return total?.textContent?.trim() || '';
}

function isDrawerOpen() {
	const drawer = document.getElementById('dc-cart-drawer');
	return Boolean(drawer && !drawer.hidden && drawer.classList.contains('is-open'));
}

function scrollToCheckoutBlocker() {
	const previews = document.querySelector('[data-address-previews]');
	const gate =
		previews && !previews.hidden && previews.classList.contains('is-address-gate')
			? previews.querySelector('[data-address-card="shipping"]') || previews
			: null;
	const upload = document.querySelector('[data-prescription-upload]');
	const needsScript = Boolean(
		upload && !upload.querySelector('[data-prescription-list] li, .dc-prescription-upload__list li')
	);
	const paymentProblem = document.querySelector('#payment .woocommerce-error, #payment [data-payment-recovery]');
	const form = document.querySelector('[data-dc-checkout]');
	const method = form?.dataset.deliveryMethod || '';
	const needsFulfilment = method !== 'collection' && method !== 'delivery';
	const target =
		gate ||
		(needsScript ? upload : null) ||
		paymentProblem ||
		(needsFulfilment ? document.querySelector('[data-delivery-cards]') : null) ||
		document.querySelector('[data-checkout-contact]') ||
		document.querySelector('[data-checkout-payment]');
	target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

function gatewayButtonLabel(placeOrder) {
	return placeOrder?.value || getConfig().i18n?.placeOrder || 'Place order';
}

export function initStickyCheckout() {
	if (!document.body.classList.contains('woocommerce-checkout')) {
		return;
	}

	const target = document.querySelector('[data-checkout-payment], #place_order, .dc-checkout__pay');
	if (!target) {
		return;
	}

	const bar = document.createElement('div');
	bar.className = 'dc-sticky-checkout';
	bar.hidden = true;
	bar.setAttribute('data-sticky-checkout', '');

	const total = document.createElement('span');
	total.className = 'dc-sticky-checkout__total';
	total.setAttribute('data-sticky-checkout-total', '');

	const button = document.createElement('button');
	button.type = 'button';
	button.className = 'dc-sticky-checkout__button';
	button.setAttribute('data-sticky-checkout-submit', '');

	button.addEventListener('click', () => {
		const placeOrder = document.querySelector('#place_order');
		if (!placeOrder || placeOrder.disabled || !checkoutCanSubmit()) {
			scrollToCheckoutBlocker();
			return;
		}
		placeOrder.click();
	});

	bar.append(total, button);
	document.body.appendChild(bar);

	const mq = window.matchMedia('(max-width: 767px)');

	const sync = () => {
		const placeOrder = document.querySelector('#place_order');
		total.textContent = readTotal();
		button.textContent = gatewayButtonLabel(placeOrder);
		button.disabled = !checkoutCanSubmit() || Boolean(placeOrder?.disabled);
	};

	const updateVisibility = (inView) => {
		const show = mq.matches && !inView && !isDrawerOpen();
		bar.hidden = !show;
		document.body.classList.toggle('dc-sticky-checkout-visible', show);
	};

	let inView = true;
	const observer = new IntersectionObserver(
		(entries) => {
			inView = Boolean(entries[0]?.isIntersecting);
			updateVisibility(inView);
		},
		{ root: null, threshold: 0, rootMargin: '0px' }
	);
	observer.observe(target);

	mq.addEventListener('change', () => updateVisibility(inView));
	const onUpdated = () => {
		syncCheckoutSubmitState();
		sync();
		window.setTimeout(() => updateVisibility(inView), 0);
	};
	if (typeof window.jQuery !== 'undefined') {
		window.jQuery(document.body).on('updated_checkout', onUpdated);
	}
	document.body.addEventListener('updated_checkout', onUpdated);
	document.addEventListener('dc:checkout-submit-state', () => sync());

	const drawer = document.getElementById('dc-cart-drawer');
	if (drawer) {
		const drawerObserver = new MutationObserver(() => updateVisibility(inView));
		drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['hidden', 'class'] });
	}

	sync();
}
